/**
 * @version 1.0.1
 * @author wuwg  <wuwg@thunisoft.com>
 * @createTime:2019-08-13,
 * @updateTime:2019-08-13
 * @copyright thunisoft fd
 * @description  *  [jsDoc中文文档]{@link  http://www.dba.cn/book/jsdoc/JSDOCKuaiBiaoQianBLOCKTAGS/CONSTRUCTS.html}
 *  [jsdoc-vuejs]{@link  http://npm.taobao.org/package/jsdoc-vuejs}  -
 *  [个人博客]{@link  http://www.wuweigang.com}
 */
export default {
    name: 'lltt',
    data() {
        return {
            crumbsList:Object.freeze([{
                name:'理论探讨',
                key:'lltt'
            }]),
            data: {
                dywz: {
                    image: '/static/image/ejym/lltt/img-dywz.png',
                    data: []
                },
                spnk: {
                    image: '/static/image/ejym/lltt/img-spnx.png',
                    data: []
                }
            }
        };
    },
    created() {
        this.initdata();
    },
    methods: {
        // 查看更多
        handleMore(type) {
            this.$router.push({
                path: '/lltt/more',
                query: {tab: type}
            });
        },
        // 查看详情
        handleDetail(item) {
            const url = this.$router.resolve({path: '/lltt/dedail', query: {active:'lltt', bh: item.bh, ejlb: item.ejlb}});
            window.open(url.href, '_blank');
            window.console.log('查看详情', item);
        },
        initdata() {
            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,
                url: window.fdConfig.url.Hsal.hsalindex.replace('{id}', '1')
            }).then((res) => {
                this.data.dywz.data = res.data.dywz;
                this.data.spnk.data = res.data.spnk;
            })
                .catch(() => {
                    Artery.notice.warning({
                        title: '失败',
                        desc: '查询列表失败！',
                        duration: 1
                    });
                });
        }
    }
};

